import { Amount } from "../types/amount";
import { DEFAULT_LOCALE } from "../config/locales";
import { DEFAULT_DECIMAL_SEPARATOR, FALLBACK_DISPLAY_DECIMALS } from "../config/consts";
import { Token } from "../store/global/TokenEnum";
import { TokenList } from "../store/global/getAllTokenLists";
import { NumberParser } from "../types/NumberParser";

/**
 *
 * TODO: Deprecate these
 */

/** @deprecated - Use Underlying DecimalJS methods **/
export const transformNumberToAmount = (valueToTransform: number): Amount => {
  return new Amount(valueToTransform.toString());
};

export const fallbackDisplayDecimals = (
  symbol: Token,
  tokenList: TokenList | undefined
): number => {
  return tokenList?.[symbol]?.displayDecimals ?? FALLBACK_DISPLAY_DECIMALS;
};

interface FormatLocaleNumberArgs {
  number: string;
  locale: string | null | undefined;
  displayDecimals: number;
  options?: Intl.NumberFormatOptions;
}

// Format's numbers to apply relevant language-sensitive number formatting.
export default function formatLocaleNumber({
  number,
  locale,
  displayDecimals,
  options = { minimumFractionDigits: displayDecimals, maximumFractionDigits: displayDecimals },
}: FormatLocaleNumberArgs): string {
  const localeArg = locale ?? DEFAULT_LOCALE;
  return parseFloat(number).toLocaleString(localeArg, options);
}

// To handle currency inputs decimal separator value
export function getDecimalSeparator() {
  const numberWithDecimalSeparator = 1.1;
  const maybeNumber = Intl.NumberFormat(navigator.language)
    .formatToParts(numberWithDecimalSeparator)
    .find(part => part.type === "decimal");
  const decimalSeparatorMatch = maybeNumber?.value;
  return decimalSeparatorMatch ?? DEFAULT_DECIMAL_SEPARATOR;
}

export function isDecimal(maybeDecimal: string) {
  const decimalMatcherRegex = /^\d*((\.|,)\d{1,})?$/;
  return decimalMatcherRegex.test(maybeDecimal);
}

export function parseAmountForInput(amount: Amount | undefined) {
  const decimalSeparator = getDecimalSeparator();
  return amount == null || amount.value.isZero()
    ? ""
    : amount.value.toString().replace(".", decimalSeparator);
}

export function parseInputToAmount(input: string | undefined) {
  const locale = navigator.language;
  const parser = new NumberParser(locale);

  if (input == null) {
    return new Amount("0.0");
  }
  if (isDecimal(input)) {
    return parser.parse(input);
  }
}

export function isZero(value: string) {
  if (value === "") return true;
  const decimalSeparator = getDecimalSeparator();
  const [whole, fraction] = value.split(decimalSeparator);
  if (Number(whole) !== 0) return false;
  if (fraction != null && Number(fraction)) return false;
  return true;
}
